import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-block-categories',
    templateUrl: './block-categories.component.html',
    styleUrls: ['./block-categories.component.scss']
})
export class BlockCategoriesComponent {
    @Input() header = '';
    @Input() layout: 'classic' | 'compact' = 'classic';
    @Input() categories: any[] = [];

    colorlist = ['#cdb4db', '#ffc8dd', '#ffafcc', '#bde0fe', '#ffb4a2', '#ccd5ae', '#a8dadc', '#00b4d8', '#ffb4a2'];

    constructor() { }

    colors(i): string {
        return ' background-color:' + this.colorlist[i];
    }

}
